'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import ClearAllFiltersButtonComponent from 'components/consumer/consumer-search/advanced-search-next/components/ClearAllFiltersButton';
import CategorySearchBox from './CategorySearchBox';
import CategoryFacetFilter from './CategoryFacetFilter';
const SKIP_FILTER_IDS = new Set(['quickship', 'color', 'widthRange', 'search']);
const CategoryAlgoliaSidebar = t0 => {
  const $ = _c(22);
  const {
    pageName,
    filters,
    selectedFacets,
    onToggleFacet
  } = t0;
  const {
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  let t1;
  if ($[0] !== filters) {
    t1 = filters || [];
    $[0] = filters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = t1.filter(_temp);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const dynamicFilters = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ClearAllFiltersButtonComponent />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== pageName) {
    t4 = <CategorySearchBox pageName={pageName} />;
    $[5] = pageName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleToggleReadyToShip || $[8] !== isReadyToShipActive) {
    t5 = <QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} />;
    $[7] = handleToggleReadyToShip;
    $[8] = isReadyToShipActive;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <WidthRangeFilter showTitle={true} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dynamicFilters || $[12] !== onToggleFacet || $[13] !== selectedFacets) {
    let t8;
    if ($[15] !== onToggleFacet || $[16] !== selectedFacets) {
      t8 = filter => <CategoryFacetFilter key={filter.id} attribute={filter.id} label={filter.label} options={filter.options} selectedValues={selectedFacets?.[filter.id] || new Set()} onToggle={onToggleFacet} />;
      $[15] = onToggleFacet;
      $[16] = selectedFacets;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t7 = dynamicFilters.map(t8);
    $[11] = dynamicFilters;
    $[12] = onToggleFacet;
    $[13] = selectedFacets;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t7) {
    t8 = <div className="pb-4">{t3}<div className="flex flex-col gap-5">{t4}{t5}{t6}{t7}</div></div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
CategoryAlgoliaSidebar.propTypes = {
  pageName: PropTypes.string,
  filters: PropTypes.array,
  selectedFacets: PropTypes.object,
  onToggleFacet: PropTypes.func
};
export default CategoryAlgoliaSidebar;
function _temp(f) {
  return !SKIP_FILTER_IDS.has(f.id) && f.options?.length > 0;
}